/**
 * Formata um Date como 'YYYY-MM-DD' usando o fuso LOCAL do navegador.
 *
 * Por que existe: Date.toISOString() converte para UTC. Se o usuario esta em
 * UTC-3 (Brasilia) e o instante eh 22h local, o UTC eh 01h do dia seguinte e
 * toISOString().slice(0,10) devolve o dia errado. Bug observado em prod em
 * 2026-05-20 (heatmap /produtos/previsao-numerica-tempo retornando images:[]
 * na 1a tentativa).
 *
 * Use SEMPRE este helper para extrair a "data civil" local de um Date que
 * sera enviado ao backend como string YYYY-MM-DD ou exibida ao usuario.
 */
export default function formatLocalDate(date: Date): string {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
